import React from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import moment from "moment";
import { RaisedButton, TextField, Link } from "material-ui";
import { debounce } from "lodash";

const NEW_USER = "NEW";

class TransferHistoryTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      sorted: [],
      page: -1,
      selectedChange: "",
      selectedIndex: null
    };

    this.cleanSundanceEmail = this.cleanSundanceEmail.bind(this);
  }

  cleanSundanceEmail(email) {
    if (typeof email !== "string") {
      return "";
    }
    if (email.indexOf("%%%sundance-") !== -1) {
      return email.substring(0, email.indexOf("%%%sundance-"));
    }
    else {
      return email;
    }
  }

  render() {
    const { loading, isPass, isTicket } = this.props;
    let { records } = this.props;

    // clean up sundance email addresses
    records = records.map(r => {
      if (r.from_person) {
        r.from_person.email = this.cleanSundanceEmail(r.from_person.email);
      }
      if (r.to_person) {
        r.to_person.email = this.cleanSundanceEmail(r.to_person.email);
      }
      if (r.to_email) {
        r.to_email = this.cleanSundanceEmail(r.to_email);
      }
      return r;
    });

    let columns = [
      {
        id: "created_at",
        Header: "Date/Time",
        Cell: function(data) {
          return moment(data.original.created_at).format("lll")
        }
      }
    ];

    if (isPass) {
      columns = columns.concat([
        {
          id: "pass_name",
          Header: "Pass",
          Cell: function(data) {
            return (<div><a href={`/passes/${data.original.passes[0]._id}`}>{data.original.passes[0].name}</a></div>);
          }
        }
      ]);
    }
    /*else if (isTicket) {
      columns = columns.concat([
        {
          id: "ticket_id",
          Header: "Ticket",
          Cell: function(data) {
            return (<div>{data.original.tickets[0].name}</div>);
          }
        }
      ]);
    }*/

    columns = columns.concat([
      {
        id: "from_person",
        Header: "Transferred From",
        Cell: function(data) { 
          return (<div><a href={`/people/${data.original.from_person._id}`}>{data.original.from_person.name}</a><br/>{data.original.from_person.email}</div>);
        }
      },
      {
        id: "to_person",
        Header: "Transferred To",
        Cell: function(data) { 
          if (data.original.to_person) {
            return (<div><a href={`/people/${data.original.to_person._id}`}>{data.original.to_person.name}</a><br/>{data.original.to_email}</div>);
          }
          else {
            return (<div>{data.original.to_email}</div>);
          }
        }
      },
      {
        id: "status",
        Header: "Status",
        width: 100,
        Cell: function(data) { 
          if (data.original.completed_at) {
            return (<div style={{ paddingLeft: 4 }}>Completed</div>);
          }
          else {
            return (<div style={{ paddingLeft: 4 }}>Pending</div>);
          }
        }
      },
      {
        id: "gift",
        Header: "Gift",
        width: 50,
        Cell: function(data) { 
          if (data.original.gift) {
            return (<div style={{ paddingLeft: 4 }}>Yes</div>);
          }
          else {
            return (<div style={{ paddingLeft: 4 }}>No</div>);
          }
        }
      }
    ]);

    return (
      <div>
        <ReactTable
          columns={columns}
          data={records}
          loading={loading}
          manual
          pageSize={records && records.length || 1}
          showPagination={false}
          showPageSizeOptions={false}
          sortable={false}
        />
      </div>
    );
  }
}

export default TransferHistoryTable;


// WEBPACK FOOTER //
// ./src/app/components/partials/transfer-history-table.jsx